import { filterProps } from '@roc/ui/utils';
import { GridColumnProps } from '@roc/ui';

export enum AutomationTechDashboardTab {
  TECH_QUEUE,
  NON_TECH_QUEUE,
}

export const DEFAULT_SORT_MODEL = [{ colId: 'minsInQueue', sort: 'desc' }];

export const techQueueColumns: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan Id',
    cellRenderer: 'loanIdCellRenderer',
    maxWidth: 120,
    ...filterProps(),
  },
  {
    field: 'taskId',
    headerName: 'Task Id',
    maxWidth: 120,
    ...filterProps(),
  },
  {
    field: 'propertyAddress',
    headerName: 'Property Address',
    minWidth: 160,
    ...filterProps(),
  },
    {
    field: 'fileName',
    headerName: 'File Name',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'minsInQueue',
    headerName: 'Delay',
    maxWidth: 120,
    ...filterProps(),
  },
  {
    field: 'type',
    headerName: 'Type',
    maxWidth: 200,
    ...filterProps(),
  },
  {
    field: 'uploadedTs',
    headerName: 'Uploaded Date',
    maxWidth: 200,
    ...filterProps(),
  },
];
